export default "__VITE_ASSET__1ec2f195__"